import React, { useState, useEffect } from "react";
import {
  Select,
  Form,
  Input,
  Button,
  Upload,
  Row,
  DatePicker,
  message,
  Cascader,
} from "antd";
const { RangePicker } = DatePicker;
import { UploadOutlined } from "@ant-design/icons";
import moment from "moment";
import AddModal from "@components/Modal";
import InspectionApi from "@api/inspectionnew";
import DepartmentApi from "@api/department";
import { disabledDate, disabledTime } from "@utils/common";

const layout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 20 },
};
export default ({
  defectOrderId,
  pid,
  title,
  visible,
  cancel,
  timeLimit = [],
}) => {
  const [form] = Form.useForm();
  const [formValue] = useState({
    defectOrderId,
  });
  const [loading, setLoading] = useState();
  // 所有的树形id
  const [deptList, setDeptList] = useState([]);
  const [defectsLs, setDefectsLs] = useState([]);
  const [imageUrls, setImageUrls] = useState([]);
  const [personList, setPersonList] = useState([]);
  const [timesLimit, setTimesLimit] = useState([]);

  useEffect(() => {
    getDefects();
    getDept();
  }, [visible]);

  useEffect(() => {
    setTimesLimit(timeLimit);
  }, [timeLimit]);

  const [usersParams, setUsersParams] = useState({
    deptId: 0,
    stationId: 0,
  });

  const getDefects = () => {
    InspectionApi.defectList({ handleStatusList: [0, 1] }).then((res) => {
      if (res.status == 0 && res.data) {
        setDefectsLs(res.data);
      }
      // 如果是新增子工单
      if (defectOrderId) {
        const filt = res.data.filter((item) => item.id === defectOrderId)[0];
        let params = usersParams;
        params.stationId = filt.stationId;
        setUsersParams({
          ...params,
        });
      }
    });
  };

  useEffect(() => {
    if (usersParams.deptId && usersParams.stationId) {
      getUsers();
    }
  }, [usersParams]);

  const getDept = async () => {
    // 查询部门
    const res = await DepartmentApi.getDeptForTree({});
    if (!res.status) return;
    setDeptList(res.data);
  };

  // 切换部门查询部门负责人
  const changeDept = (e) => {
    if (!e) return;
    let params = usersParams;
    params.deptId = e[e.length - 1];
    setUsersParams({
      ...params,
    });
  };

  const chooseDefect = (e) => {
    if (!e) return;
    form.setFieldsValue({ time: [] });
    const filt = defectsLs.filter((item) => item.id === e)[0];
    const { stationId, createAt, planCloseTime } = filt;
    let params = usersParams;
    params.stationId = stationId;
    setTimesLimit([createAt, planCloseTime]);
    setUsersParams({
      ...params,
    });
  };

  // 获取用户列表
  const getUsers = () => {
    form.setFieldsValue({ handleUserIds: [] });
    DepartmentApi.getUsersByDeptId({ ...usersParams }).then((res) => {
      if (res.status !== "0") return;
      setPersonList(res.data);
    });
  };

  // 提交
  const submit = () => {
    form.validateFields().then((values) => {
      if (!values) return;
      setLoading(true);
      let param = {
        beginTime: moment(values.time[0]).format("YYYY-MM-DD HH:mm:ss"),
        endTime: moment(values.time[1]).format("YYYY-MM-DD HH:mm:ss"),
        handleUserIds: values.handleUserIds,
        workOrderContent: values.workOrderContent,
        workOrderTitle: values.workOrderTitle,
        defectOrderId: values.defectOrderId,
        deptId: values.deptId[values.deptId.length - 1],
        imageUrls,
      };
      if (pid !== null) {
        param.pid = pid;
      }
      InspectionApi.workOrderAdd(param)
        .then((res) => {
          if (res.status == 0) {
            message.success("新增成功");
            handelCancel(true);
          }
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    });
  };

  // 上传前进行图片限制处理
  const beforeUpload = (file) => {
    const isJpgOrPng =
      file.type === "image/jpg" ||
      file.type === "image/jpeg" ||
      file.type === "image/png";
    if (!isJpgOrPng) {
      message.error("图片格式不正确!");
    }
    const isLt2M = file.size / 1024 / 1024 < 7;
    if (!isLt2M) {
      message.error("图片最大7M!");
    }
    return isJpgOrPng && isLt2M;
  };

  const uploadResultImg = (info) => {
    const { file } = info;
    if (file.status === "done") {
      const { response: res } = file;
      if (res.status !== "0") return;
      setImageUrls([...imageUrls, res.data.url]);
    }
  };

  const removeResultImg = (info) => {
    const { response: res } = info;
    const url = res.data.url;
    const params = imageUrls;
    const index = params.findIndex((item) => item === url);
    params.splice(index, 1);
    setImageUrls([...params]);
  };

  // 取消
  const handelCancel = (bool) => {
    form.resetFields();
    cancel(bool);
  };

  return (
    <AddModal
      title={title}
      footer={[
        <Row key={"btn"} span={24}>
          <Button
            key={1}
            onClick={() => handelCancel(false)}
            className="abuttons"
          >
            <i className="iconfont iconfanhui"></i>&nbsp;&nbsp;取消
          </Button>
          <Button
            key={2}
            loading={loading}
            onClick={submit}
            className="abuttons"
            type="primary"
          >
            <i className="iconfont iconbaocun"></i>&nbsp;&nbsp;保存
          </Button>
        </Row>,
      ]}
      visible={visible}
      width={600}
      okText={"确定"}
      onCancel={() => handelCancel(false)}
      onSubmit={() => submit()}
    >
      <Form
        {...layout}
        layout="horizontal"
        form={form}
        initialValues={formValue}
      >
        <Form.Item
          label="工单标题"
          name="workOrderTitle"
          rules={[{ required: true, message: "请输入工单标题!" }]}
        >
          <Input placeholder="请输入工单标题"></Input>
        </Form.Item>
        <Form.Item
          label="缺陷单"
          name="defectOrderId"
          rules={[{ required: true, message: "请选择缺陷单" }]}
        >
          <Select
            disabled={defectOrderId ? true : false}
            placeholder="请选择缺陷单"
            onChange={chooseDefect}
          >
            {defectsLs.length > 0 &&
              defectsLs.map((item) => {
                return (
                  <Select.Option value={item.id} key={item.id}>
                    {item.deffectRemark}
                  </Select.Option>
                );
              })}
          </Select>
        </Form.Item>
        <Form.Item
          label="负责部门"
          name="deptId"
          rules={[{ required: true, message: "请选择负责部门" }]}
        >
          <Cascader
            fieldNames={{
              label: "name",
              value: "id",
              children: "children",
            }}
            options={deptList}
            onChange={(e) => {
              changeDept(e);
            }}
            placeholder="请选择负责部门"
          />
        </Form.Item>
        <Form.Item
          label="处理人"
          name="handleUserIds"
          rules={[{ required: true, message: "请选择处理人" }]}
        >
          <Select mode="multiple" placeholder="请选择处理人">
            {personList.length > 0 &&
              personList.map((item) => {
                return (
                  <Select.Option value={item.id} key={item.id}>
                    {item.realName}
                  </Select.Option>
                );
              })}
          </Select>
        </Form.Item>
        <Form.Item
          label="工单内容"
          name="workOrderContent"
          rules={[{ required: true, message: "请填写工单内容" }]}
        >
          <Input.TextArea row={4} placeholder="请输入工单内容" />
        </Form.Item>
        <Form.Item
          label="截止时间"
          name="time"
          rules={[{ required: true, message: "请选择截止时间" }]}
        >
          <RangePicker
            disabledDate={(current) => disabledDate(current, timesLimit)}
            disabledTime={(current, type) =>
              disabledTime(current, type, timesLimit)
            }
            showTime
          />
        </Form.Item>
        <Form.Item label="上传图片">
          <Upload
            name="file"
            action={window.globalConfig.UPLOADER}
            headers={{ authorization: sessionStorage.getItem("token") }}
            beforeUpload={(e) => beforeUpload(e)}
            onChange={(e) => uploadResultImg(e)}
            onRemove={(e) => removeResultImg(e)}
          >
            <Button icon={<UploadOutlined />}>上传图片</Button>
          </Upload>
        </Form.Item>
      </Form>
    </AddModal>
  );
};
